import { Component } from '@angular/core';
import { slideInAnimation } from './app.component.animations';
import { ChildrenOutletContexts } from '@angular/router';
import { GoogleMapsLoaderService } from '@services';

@Component({
  selector: 'unicon-root',
  templateUrl: './app.component.html',
  animations: [slideInAnimation],
})
export class AppComponent {
  constructor(
    private contexts: ChildrenOutletContexts,
    private mapsLoader: GoogleMapsLoaderService,
  ) {}

  async ngOnInit() {
    try {
      await this.mapsLoader.load();
    } catch (error) {
      console.error('Error al cargar Google Maps:', error);
    }
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
}
